import { configureStore } from '@reduxjs/toolkit';
import priceReducer from 'src/views/global/pigPrice/store/slice';
import homeReducer from 'src/views/home/store/homeSlice';
import inspectionReducer from 'src/views/Inspection/store/index';
import globalReducer from './global/globalSlice';

const store = configureStore({
  reducer: {
    global: globalReducer,
    home: homeReducer,
    price: priceReducer,
    inspectionStore: inspectionReducer
  }
});

export default store;
